import { Box, Button, IconButton, Paper, Tooltip, Typography, useTheme } from '@mui/material'
import { useTranslation } from 'react-i18next'
import React from 'react'

import requestSentImg from '../../../assets/sent.svg'
import { Icons } from '../../../utils/utilities'

const copyContactNumber = () => {
    navigator.clipboard.writeText( `+998553010009` )
        .then( () => {
            console.log( "Text copied to clipboard successfully!" )
        } )
        .catch( err => {
            console.error( "Failed to copy text: ", err )
        } )
}

export default function ReattemptRequested ( { onBack } ) {

    const { t } = useTranslation()
    const { palette } = useTheme()

    return (
        <Box component={Paper} sx={{ borderRadius: "10px", padding: "20px", maxWidth: "400px" }}>
            <Box sx={{ display: "flex", flexDirection: "column", gap: "20px", alignItems: "center" }} >

                <Box sx={{ display: "flex", flexDirection: "column", gap: "10px", alignItems: "center" }} >``
                    <Box component="img" src={requestSentImg} width="160px" alt="Request sent" />
                    <Typography variant='h6' textAlign="center" sx={{ fontSize: "1.6rem", lineHeight: 1.1 }}>{t( 'candidateLogin.reattempRequestSent' )}</Typography>
                    <Typography variant='subtitle2' textAlign="center" color='textSecondary' sx={{ fontSize: "0.875rem" }}>{t( 'candidateLogin.reattempRequestSentSubtext' )}</Typography>
                </Box>

                <Box>
                    <Button type='button' onClick={onBack} sx={{ textTransform: "capitalize", py: 1, px: 2 }} disableElevation startIcon={Icons.default.ArrowBack} size='small' variant='contained' >{t( 'button.goBack' )}</Button>
                </Box>

                <Box sx={{ display: "flex", gap: "10px", alignItems: "center", bgcolor: palette.primary.light + "11", border: `1px solid ${palette.primary.main}`, borderRadius: "10px", padding: "10px", }}>
                    <Typography component="span" variant='subtitle2' display="flex" alignItems="center"  >{Icons.default.Info}</Typography>
                    <Typography variant='subtitle2'  >{t( 'candidateLogin.contactUsForApproval' )} <Typography component="a" sx={{ fontStyle: "italic", fontSize: "inherit", color: "inherit", textDecoration: "underline !important" }} className='default-link' href={`tel:+998553010009`} >+998 553010009</Typography></Typography>
                    <Tooltip title={t( 'candidateLogin.contactTooltip' )}>
                        <IconButton onClick={() => copyContactNumber()} size='small'>
                            {Icons.default.CopyAll}
                        </IconButton>
                    </Tooltip>
                </Box>
            </Box>

        </Box>
    )
}
